
import { Button } from "@/components/ui/button";
import { PlusCircle } from "lucide-react";
import { useNavigate } from "react-router-dom";

const EmptyProductState = () => {
  const navigate = useNavigate();
  
  return (
    <div className="text-center py-12">
      <h3 className="text-lg font-medium text-gray-600 dark:text-gray-300 mb-4">
        No products added yet
      </h3>
      <p className="text-gray-500 dark:text-gray-400 mb-6">
        Start by adding your first product to track
      </p>
      <Button 
        className="bg-blue-500 hover:bg-blue-600"
        onClick={() => navigate("/products/add")}
      >
        <PlusCircle className="mr-2 h-4 w-4" />
        Add Your First Product
      </Button>
    </div>
  );
};

export default EmptyProductState;
